import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "app/shared/shared.module";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

import { SearchResultsLayoutComponent } from "./search-results-layout/search-results-layout.component";
import { InventoryModule } from "@rubbl-inventory";
import { SearchResultsSharedModule } from "./search-results-shared/search-results-shared.module";

const routes: Routes = [
  {
    path: "",
    component: SearchResultsLayoutComponent,
    data: { hideFooter: true },
    children: [
      {
        path: "equipment-rentals",
        loadChildren: () => import("./search-results-grid/search-results-grid.module").then(m => m.SearchResultsGridModule),
        data: { searchView: "grid" },
      },
      {
        path: "map",
        loadChildren: () => import("./search-results-map/search-results-map.module").then(m => m.SearchResultsMapModule),
        data: { searchView: "map" },
      },
    ],
  },
];

@NgModule({
  declarations: [SearchResultsLayoutComponent],
  imports: [RouterModule.forChild(routes), CommonModule, SharedModule, FormsModule, InventoryModule, SearchResultsSharedModule],
})
export class SearchResultsModule {}
